import React from 'react'
import { ActionButton } from '@emerald-works-nova/components'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography
} from '@mui/material'

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      data-test='confirmation-modal'
      fullWidth
      maxWidth='sm'
    >
      <DialogTitle>Delete User Account?</DialogTitle>
      <Divider sx={{ margin: '0 auto', width: '90%' }} />
      <DialogContent>
        <Typography variant='caption' color='textSecondary' sx={{ display: 'block' }}>
          Deleting this user will permanently remove their data from the system. This action cannot be undone.
        </Typography>
        <Typography variant='caption' color='textSecondary' sx={{ marginTop: 2, display: 'block' }}>
          Are you sure you want to proceed?
        </Typography>
      </DialogContent>
      <DialogActions>
        <ActionButton
          onClick={onClose}
          variant='secondary'
          noBorder='true'
          dataTest='confirmation-modal-close'
        >
          Cancel
        </ActionButton>
        <ActionButton
          onClick={onConfirm}
          variant='secondary'
          noBorder='true'
          dataTest='confirmation-modal-confirm'
        >
          Confirm
        </ActionButton>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationModal
